import RoutePath from 'router/path';

export const KEYS = {
  PWC_ROUTE_MATCH: `${RoutePath.Pwc.Accounts.ById}/:route`,
  RAMP_ROUTE_MATCH: `${RoutePath.AccountSettings.Users}/:route`,
  PWC_URL_PATH: 'pwc',
};

export default KEYS;
